const routes = [
    {
        path: "/student/id/card",
        component: () => import("./Index"),
        permission:'studentcard_studentcards'
    }
];

export default routes;
